<template>
  <div>
    <a-input-group>
      <FieldWYSIWYG
        v-model="comment"
        :field="comment_settings">
      </FieldWYSIWYG>
      <br/>
      <template v-if="id !== null">
        <a-button
          type="primary"
          @click="saveComment"
          :loading="loading"
          :disabled="button_disabled"
        >
          {{ $t('history.verb.save_comment') }}
        </a-button>
        <a-button
          style="margin-left: 10px"
          @click="cancelEdit"
        >
          {{ $t('history.verb.cancel') }}
        </a-button>
      </template>
      <a-button
        v-else
        type="primary"
        @click="addComment"
        :loading="loading"
        :disabled="button_disabled"
      >
        {{ $t('history.verb.send_comment') }}
      </a-button>
    </a-input-group>
  </div>
</template>

<script>
import Entity from '@/api/entity'
import { EventBus } from '@/event-bus'
import FieldWYSIWYG from '@/components/fields/wysiwyg/FieldWYSIWYG'

export default {
  name: 'CommentsForm',
  components: {
    FieldWYSIWYG,
  },
  data () {
    return {
      comment: this.data,
      loading: false,
      button_disabled: true,
      comment_settings: {
        options: {
          height: '100px'
        }
      }
    }
  },
  props: {
    resource: {
      type: Entity,
      default: undefined,
    },
    data: {
      type: String,
      default: null,
    },
    id: {
      type: Number,
      default: null,
    },
  },
  watch: {
    comment (val) {
      if (val.trim().length !== 0) {
        this.button_disabled = false
      } else {
        this.button_disabled = true
      }
    },
  },
  methods: {
    addComment () {
      this.loading = true
        this.resource.addComment(this.comment.trim())
        .then(response => {
          this.loading = false
          this.comment = ''
          EventBus.$emit('reloadHistory')
          return response
        })
    },
    saveComment () {
      this.loading = true
      this.resource.saveComment(this.comment.trim(), this.id)
        .then(response => {
          this.loading = false
          this.comment = ''
          EventBus.$emit('reloadHistory')
          return response
        })
    },
    cancelEdit () {
      EventBus.$emit('cancelEdit', this.id)
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
